import { render } from "./RegisterStylist.vue?vue&type=template&id=c54cf00c&scoped=true"
import script from "./RegisterStylist.vue?vue&type=script&lang=js"
export * from "./RegisterStylist.vue?vue&type=script&lang=js"

import "./RegisterStylist.vue?vue&type=style&index=0&id=c54cf00c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c54cf00c"]])

export default __exports__